import { render } from "./knowledge-base-modal.vue?vue&type=template&id=170b3113"
import script from "./knowledge-base-modal.vue?vue&type=script&lang=js"
export * from "./knowledge-base-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__